import { applyFilters, doRequest } from "./helpers";

export default class MetaSandboxAdSetService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/sandbox/adsets`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
